import React, {PropTypes} from "react";
import {Field, reduxForm} from "redux-form";
import MenuItem from "material-ui/MenuItem";
import Dates from "../../../classes/dates";
import Checkbox from "material-ui/Checkbox";
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";
import Popover from "react-bootstrap/lib/Popover";
import {DatePicker, SelectField, TextField} from "redux-form-material-ui";
import Constants from "../../../classes/constants"

const validate = values => {
  const errors = {};
  const requiredFields = ['doResignation', 'doLeaving', 'noticePeriodStatus', 'typeOfExit', 'status', 'remarks'];
  let d = new Dates();
  if (values['doResignation'] != null && values['doLeaving'] != null) {
    //let days = d.dateDifference(values['doResignation'], values['doLeaving']);
  }

  if (values['doLeaving'] == null) {
    errors['doLeaving'] = 'Required';
  }
  if (typeof(values['remarks']) == 'string')
    if (values['remarks'].trim().length == 0)
      errors['remarks'] = 'Required';
  requiredFields.forEach(field => {

    if (!values[field]) {
      errors[field] = 'Required'
    }
  });
  return errors;
};
const asyncValidate = (values) => {
  return Promise.resolve({remarks: 'required'});

};


class ApplyExit extends React.Component {

  constructor(props) {
    super(props);
    if(props.employee.imageUrl != undefined){
      this.state = {src: props.employee.imageUrl, disp:"none",showRecovery: false, error: "", gardening: true,
      serving: 'none', served: 'none', abscond: 'none', recover:'none', gardeningDisplay:'none', business :'none', termination:'none'};
    }
    else{
      this.state = {showRecovery: false, error: "", gardening: true,
      serving: 'none', served: 'none', abscond: 'none', recover:'none', gardeningDisplay:'none', business :'none', termination: 'none'};
    }
  }

  componentDidMount() {
    if (this.props.employee.noticePeriodStatus == 'Gardening')
      this.setState({gardening: false});
    if (this.props.employee.recovery != null && this.props.employee.recovery != 0)
      this.setState({showRecovery: true});
  }

  render() {
    const {handleSubmit, reset} = this.props;
    let exitText = "Upload respective exit employee's resignation mail screenshot / image (JPEG/PNG/PDF & < 2MB)";
    return (<div className="col-md-12">
        <form encType="multipart/form-data" onSubmit={handleSubmit(data => {
          if(!this.state.file  && this.props.employee.imageUrl == undefined){
             alert("Upload image");
              this.setState({error: 'Upload Image'});
              return;
            }
          if (this.state.showRecovery) {
            if (data.recovery == parseInt(data.recovery, 10) && !isNaN(data.recovery)) {
              if (data.recovery > 90) {
                this.setState({error: 'Days should be less than 90'});
                return;
              }
            }
            else {
              this.setState({error: "Please Enter a number"});
              return;
            }
          }
          let request = Object.assign({}, data);
          if(this.props.employee.imageUrl == undefined){
            let exitData = new FormData();
            this.state.file.key = "picture"
            exitData.append('picture', this.state.file, "image.jpg");
            for (var value of exitData.values()) {
              request.file = value
            }
          }

          if (this.state.showRecovery) {
            this.setState({error: ""})
            this.props.applyExit(request, data.recovery);
          }
          else
          {
            this.props.applyExit(request, null);
          }
        })}>
          <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
            <thead>
            <tr>
              <th cellPadding="0" colSpan="4">
                <span
                  className="bold pull-left">{this.props.employee.employeeCode}&nbsp;&nbsp;{this.props.employee.name}</span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style={{color: 'black', align: 'left', width: '18%'}}>Email Id:</td>
              <td style={{fontSize: '16px', align: 'left', width: '28%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    {this.props.employee.emailId}
                  </span>
              </td>

              <td style={{color: 'black', align: 'left', width: '18%'}}>Reporting Manager:</td>
              <td style={{fontSize: '16px', align: 'left', width: '28%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    {this.props.employee.reportingTo}&nbsp;{this.props.employee.managerName}
                  </span>
              </td>
            </tr>
            <tr>
              <td style={{color: 'black', align: 'left', width: '18%'}}>Reasons for leaving:</td>
              <td style={{
                fontSize: '16px',
                align: 'left',
                width: '28%',
                padding: 0,
                paddingLeft: '1%',
                paddingTop: '1%'
              }}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    {this.props.employee.employeeRemarks}
                  </span>
              </td>
              <td style={{color: 'black', align: 'left', width: '18%'}}>Location:</td>
              <td style={{fontSize: '16px', align: 'left'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                    {this.props.employee.location}
                    </span>
              </td>
            </tr>
            <tr>
              <td style={{color: 'black', align: 'left', width: '18%'}}>Notice Period:</td>
              <td style={{
                fontSize: '16px',
                align: 'left',
                width: '28%',
                padding: 0,
                paddingLeft: '1%',
                paddingTop: '1%'
              }}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    {this.props.employee.noticePeriod ? this.props.employee.noticePeriod + "days" : ' '}
                  </span>
              </td>
            </tr>
            <tr>
              <td style={{color: 'black', align: 'left', width: '18%'}}>Date of Resignation:</td>
              <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                     <Field name="doResignation"
                            component={DatePicker}
                            formatDate={(date)=> {
                              return (date.toString().substring(0, 16));
                            }}
                            autoOk={true}
                            textFieldStyle={{width: '100%'}}
                            defaultValue={null} // DatePicker requires an object,
                       // and redux-form defaults to ''
                            hintText="Date of Resignation "/>
                  </span>
              </td>
              <td style={{color: 'black', align: 'left', width: '18%'}}>Last Working Day:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                    <Field name="doLeaving"
                           fullWidth={true}
                           component={DatePicker}
                           formatDate={(date)=> {
                             return (date.toString().substring(0, 16));
                           }}
                           autoOk={true}
                           textFieldStyle={{width: '100%'}}
                           defaultValue={null} // DatePicker requires an object,// and redux-form defaults to ''
                           hintText="Last Working Day"/>
                    </span>
              </td>
            </tr>
            <tr>
              <td style={{color: 'black', align: 'left', width: '18%'}}>
                <OverlayTrigger trigger={['hover', 'focus']} placement="top"
                                overlay={ <Popover
                                  style={{width: '500px', borderStyle: 'solid'}}
                                  id="popover-trigger-hover-focus">
                                  <ul style={{paddingLeft: 0, marginLeft: 10}}>
                                    <li><u><b>Involuntary:</b></u>&nbsp; We have asked the employee to exit due to any
                                      reason
                                    </li>
                                    <li><u><b>Voluntary:</b></u>&nbsp; Employee has resigned on his/her own</li>
                                    <li><u><b>Absconding:</b></u>&nbsp; Employee is absent from work for more than 5
                                      days without approval
                                    </li>
                                  </ul>

                                </Popover>}>
                  <div>
                    Type Of Exit:
                    <img src="public/images/help.svg" style={{marginLeft: '5px'}} height="18px" width="18px"/></div>
                </OverlayTrigger></td>
              <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                       <Field
                         name="typeOfExit"
                         hintText="Type Of Exit"
                         style={{width: '100%'}}
                         component={SelectField}>
              <MenuItem value={null} primaryText="&nbsp;" disabled={false} selected={true}/>
              <MenuItem onTouchTap={(e) => {
                this.setState({serving: 'block', served: 'block', recover: 'block',
                gardeningDisplay: 'none', abscond: 'none', business: 'none', termination: 'none'});
              }} value="voluntary" primaryText="Voluntary"/>
              <MenuItem onTouchTap={(e) => {
                  this.setState({serving: 'block', served: 'block', gardeningDisplay: 'block',
                          recover: 'none', abscond: 'none', business: 'block', termination: 'block'});
              }} value="involuntary" primaryText="Involuntary"/>
              <MenuItem onTouchTap={(e) => {
                  this.setState({abscond: 'block', serving:'none', served:'none', recover:'none',
                                  gardeningDisplay: 'none', business: 'none', termination: 'none'});
              }} value="abscond" primaryText="Abscond"/>
            </Field>
                  </span>
              </td>
              <td style={{color: 'black', align: 'left', width: '18%'}}>Notice Period Status:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                      <Field
                        name="noticePeriodStatus"
                        hintText="Notice Period Status"
                        style={{width: '100%'}}
                        component={SelectField}>
                <MenuItem value={null} primaryText="&nbsp;" disabled={false} selected={true}/>
                <MenuItem onTouchTap={(e) => {
                  this.setState({gardening: true})
                }} value="Serving" primaryText="Serving" style={{display: this.state.serving}}/>

                <MenuItem onTouchTap={(e) => {
                  this.setState({gardening: true})
                }} value="Served" primaryText="Served" style={{display: this.state.served}}/>
                 <MenuItem onTouchTap={()=> {
                  this.setState({gardening: true})
                }} value="Abscond" primaryText="Abscond" style={{display: this.state.abscond}}/>

                <MenuItem onTouchTap={()=> {
                  this.setState({gardening: true})
                }} value="Recover" primaryText="Recover" style={{display: this.state.recover}}/>

                <MenuItem onTouchTap={()=> {
                  this.setState({gardening: true})
                }} value="Gardening" primaryText="Gardening" style={{display: this.state.gardeningDisplay}}/>

                <MenuItem onTouchTap={()=> {
                  this.setState({business: true})
                }} value="Business" primaryText="Business" style={{display: this.state.business}}/>
                
                <MenuItem onTouchTap={()=> {
                  this.setState({termination: true})
                }} value="Termination" primaryText="Termination" style={{display: this.state.termination}}/></Field>
                    </span>
              </td>
            </tr>

            <tr>
              <td style={{color: 'black', align: 'left', width: '18%'}}>Remarks:</td>
              <td style={{
                fontSize: '16px',
                align: 'left',
                width: '28%',
                padding: 0,
                paddingLeft: '1%',
                paddingTop: '0%'
              }}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                     <Field
                       defaultValue=""
                       name="remarks"
                       rowsMax={2}
                       multiLine={true}
                       hintText="Remarks"
                       style={{width: '100%'}}
                       component={TextField}
                     />
                  </span>
              </td>
              <td style={{color: 'black', align: 'left', width: '18%'}}><Checkbox
                onCheck={()=> {
                  this.setState({showRecovery: !this.state.showRecovery})
                }}
                label="Recovery"
                defaultChecked={this.props.employee.recovery != 0 && this.props.employee.recovery != null ? true : false}/>
              </td>
              <td style={{fontSize: '16px', align: 'left', padding: 0, paddingLeft: '1%', paddingTop: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                    {this.state.showRecovery ? <Field
                      name="recovery"
                      errorText={this.state.error}
                      hintText="Enter recovery period"
                      style={{width: '80%'}}
                      component={TextField}
                    /> : null}
                    </span>
              </td>
            </tr>
            <tr>
                <td style={{color: 'black', align: 'center', width: '18%'}}>{exitText}</td>
                <td style={{align: 'center'}}>
                  <img src={this.state.src} height="200px" width="200px" border={0}/>
                  <div style={{display: this.state.disp}}> <b> Note: </b> File size should not be more than 2 MB and format is in jpeg/png/pdf only</div>
                  <div style={{display: this.state.disp}} className="uploadButton">
                    <button className="btn btn-default">Upload</button>
                    <input type="file" onChange={(event)=> {
                      let file_size = event.target.files[0].size;
                      let file_type = event.target.files[0].type;
                      if(file_size > Constants.imageSize) {
                        this.setState({src: "", file: ""});
                        alert('File size is too big. Please upload a small size file');
                      }else{
                        if(file_type == "image/jpeg" || file_type == "image/png" || file_type == "application/pdf"){
                          var reader = new FileReader();
                          reader.onload = (e)=> {
                            this.setState({src: e.target.result})
                          };
                          reader.readAsDataURL(event.target.files[0]);
                          this.setState({file: event.target.files[0]})
                        }else{
                          this.setState({src: "", file: ""});
                          alert("File format should be in jpeg/png/pdf only");
                        }
                      }
                    }} name="exitImage" id = "exitImage" className="fileUpload" />
                  </div>
                </td>
              </tr>
              <tr>
              </tr>
            </tbody>
          </table>
          <br/>
          <button type="submit" style={{width: '25%', marginRight: '20px'}} className="btn btn-default">Save</button>
          <button type="button" onClick={reset} style={{width: '20%'}} className="btn btn-default btn-group-lg">Reset
          </button>
          <div style={{display: 'none'}}>
            <Field name="gardening"
                   component={DatePicker}
                   disabled={this.state.gardening}
                   autoOk={true}
                   textFieldStyle={{width: '100%'}}
                   defaultValue={null} // DatePicker requires an object,
              // and redux-form defaults to ''
                   floatingLabelText="Gardening Date"
                   hintText="Gardening Date"/>
          </div>
        </form>
      </div>
    );
  }
}

ApplyExit.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}


export default reduxForm({
  form: 'applyExit',
  validate,

})(ApplyExit)



/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/Forms/ApplyExit.js
 **/